import { render, staticRenderFns } from "./derivatives.vue?vue&type=template&id=5b01defd&scoped=true&"
import script from "./derivatives.vue?vue&type=script&lang=js&"
export * from "./derivatives.vue?vue&type=script&lang=js&"
import style0 from "./derivatives.vue?vue&type=style&index=0&id=5b01defd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01defd",
  null
  
)

export default component.exports